import type { WeekDay } from '../features/profile/finderSettings/types'

export interface WeekDayItem {
  /** Full day name, e.g. "Monday". */
  name: WeekDay
  /** 1-based day index, Monday = 1 … Sunday = 7. */
  index: number
  /** Stored/submitted value — same as the full name. */
  value: WeekDay
  /** Short label for compact UI (chips, card), e.g. "Mon". */
  short: string
}

export const WEEK_DAYS: WeekDayItem[] = [
  { name: 'Monday', index: 1, value: 'Monday', short: 'Mon' },
  { name: 'Tuesday', index: 2, value: 'Tuesday', short: 'Tue' },
  { name: 'Wednesday', index: 3, value: 'Wednesday', short: 'Wed' },
  { name: 'Thursday', index: 4, value: 'Thursday', short: 'Thu' },
  { name: 'Friday', index: 5, value: 'Friday', short: 'Fri' },
  { name: 'Saturday', index: 6, value: 'Saturday', short: 'Sat' },
  { name: 'Sunday', index: 7, value: 'Sunday', short: 'Sun' },
]
